const ADMIN_AUTH_KEY = 'admin_session';

const ADMIN_CREDENTIALS = [
  { email: 'Akkisarsaniya@gmail.com', password: 'Akkisarsaniya@147', name: 'Akkisarsaniya' },
  { email: 'gobindcityinfomart@gmail.com', password: 'gobindcityinfomart@147', name: 'Gobind Singh' }
];

export const adminLogin = (email, password) => {
  const match = ADMIN_CREDENTIALS.find(
    cred => cred.email.toLowerCase() === email.toLowerCase() && cred.password === password
  );
  if (match) {
    const session = { email: match.email, name: match.name };
    localStorage.setItem(ADMIN_AUTH_KEY, JSON.stringify(session));
    return { success: true, admin: session };
  }
  return { success: false };
};

export const isAdminLoggedIn = () => {
  const session = localStorage.getItem(ADMIN_AUTH_KEY);
  if (!session) return false;
  // Verify hasn't been tampered
  try {
    const parsed = JSON.parse(session);
    return ADMIN_CREDENTIALS.some(cred => cred.email.toLowerCase() === parsed.email?.toLowerCase());
  } catch {
    return false;
  }
};

export const getAdminUser = () => {
  try {
    return JSON.parse(localStorage.getItem(ADMIN_AUTH_KEY));
  } catch {
    return null;
  }
};

export const adminLogout = () => {
  localStorage.removeItem(ADMIN_AUTH_KEY);
};
